import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./modules/auth/LoginPage";
import { DashboardPage } from "./modules/dashboard/DashboardPage";
import { CustomersPage } from "./modules/masters/CustomersPage";
import { BlogsPage } from "./modules/masters/BlogsPage";
import { NewBlogPage } from "./modules/masters/NewBlogPage";
import { EditBlogPage } from "./modules/masters/EditBlogPage";
import { ViewBlogPage } from "./modules/masters/ViewBlogPage";
import { WebActivityPage } from "./modules/masters/WebActivityPage";
import { EmployeesPage } from "./modules/masters/EmployeesPage";
import { LiveChatPage } from "./modules/masters/LiveChatPage";
import { ProfilePage } from "./modules/masters/ProfilePage";
import { CustomFieldsPage } from "./modules/masters/CustomFieldsPage";
import { EnquiriesPage } from "./modules/masters/EnquiriesPage";
import { RegistrationsPage } from "./modules/masters/RegistrationsPage";
import { ProjectsPage } from "./modules/masters/ProjectsPage";
import { NewProjectPage } from "./modules/masters/NewProjectPage";
import { EditProjectPage } from "./modules/masters/EditProjectPage";
import { ViewProjectPage } from "./modules/masters/ViewProjectPage";
import { BrandsPage } from "./modules/masters/BrandsPage";
import { ProductCategoriesPage } from "./modules/masters/ProductCategoriesPage";
import { ProductsPage } from "./modules/masters/ProductsPage";
import { NewProductPage } from "./modules/masters/NewProductPage";
import { EditProductPage } from "./modules/masters/EditProductPage";
import { ViewProductPage } from "./modules/masters/ViewProductPage";
import { ServicesPage } from "./modules/masters/ServicesPage";
import { NewServicePage } from "./modules/masters/NewServicePage";
import { EditServicePage } from "./modules/masters/EditServicePage";
import { ViewServicePage } from "./modules/masters/ViewServicePage";
import { ProductEnquiriesPage } from "./modules/masters/ProductEnquiriesPage";
import { TestimonialsPage } from "./modules/masters/TestimonialsPage";
import { GalleriesPage } from "./modules/masters/GalleriesPage";
import { MediaPage } from "./modules/masters/MediaPage";
import { AppLayout } from "./layout/AppLayout";
import { RequireAuth } from "./modules/auth/RequireAuth";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customers/:customerId/employees" element={<EmployeesPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="live-chat" element={<LiveChatPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="custom-fields" element={<CustomFieldsPage />} />
        <Route path="enquiries" element={<EnquiriesPage />} />
        <Route path="registrations" element={<RegistrationsPage />} />
        <Route path="projects/new" element={<NewProjectPage />} />
        <Route path="projects/:id/edit" element={<EditProjectPage />} />
        <Route path="projects/:id/preview" element={<ViewProjectPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="brands" element={<BrandsPage />} />
        <Route path="product-categories" element={<ProductCategoriesPage />} />
        <Route path="products/new" element={<NewProductPage />} />
        <Route path="products/:id/edit" element={<EditProductPage />} />
        <Route path="products/:id/preview" element={<ViewProductPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="services/new" element={<NewServicePage />} />
        <Route path="services/:id/edit" element={<EditServicePage />} />
        <Route path="services/:id/preview" element={<ViewServicePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="product-enquiries" element={<ProductEnquiriesPage />} />
        <Route path="testimonials" element={<TestimonialsPage />} />
        <Route path="galleries" element={<GalleriesPage />} />
        <Route path="media" element={<MediaPage />} />
        <Route path="blogs/new" element={<NewBlogPage />} />
        <Route path="blogs/:id/edit" element={<EditBlogPage />} />
        <Route path="blogs/:id" element={<ViewBlogPage />} />
        <Route path="blogs" element={<BlogsPage />} />
        <Route path="web-activity" element={<WebActivityPage />} />
        <Route path="users" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
